import { Box, Grid, Link, Stack, Typography } from '@mui/material';
import { ReactElement, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useResetRecoilState } from 'recoil';

import { CompanyLogo } from '@app/components/Company/CompanyLogo';
import { searchConditionState } from '@app/domain/catalog';
import { CategoryType } from '@app/types/catalog';
import { Organization } from '@app/types/organization';
import { getChildOrgIds } from '@app/utils/catalog';

interface OrganizationHeaderProps {
  isPreview?: boolean;
  organization: Organization;
}
export function OrganizationHeader({
  organization,
  isPreview,
}: OrganizationHeaderProps): ReactElement {
  const navigate = useNavigate();
  const resetConditionState = useResetRecoilState(searchConditionState);
  const [isScrolled, setIsScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const buttonsAction = [
    {
      action: () => {
        const element = document.getElementById('model-house');
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      },
      title: '住宅展示場を探す',
    },
    {
      action: () => {
        resetConditionState();
        navigate(
          `/properties?org=${getChildOrgIds(organization)}&category=${
            CategoryType.PROPERTY
          }`
        );
      },
      title: '分譲住宅を探す',
    },
  ];
  return (
    <Stack
      py={{ sm: 1, xs: 0 }}
      gap={4}
      bgcolor="white"
      alignItems="center"
      zIndex={3}
      position="sticky"
      top={0}
    >
      <Stack
        width="100%"
        maxWidth={1000}
        maxHeight={isScrolled ? 80 : 150}
        overflow="hidden"
        direction={{ sm: 'row', xs: 'column-reverse' }}
        alignItems="center"
        display={{ sm: 'flex', xs: isPreview ? 'none' : 'unset' }}
      >
        <Box
          flex={1}
          display={{ sm: 'block', xs: 'none' }}
          width={{ sm: 'auto', xs: 240 }}
        >
          <CompanyLogo
            sx={{
              transition: 'width 0.3s ease',
              width: isScrolled ? 240 : 400,
            }}
            companyName={organization.name}
            logoUrl={organization?.customFields?.companyLogo?.url}
          />
        </Box>

        {!isPreview && (
          <Stack
            flex={1}
            alignItems="flex-end"
            width={{ sm: 'auto', xs: '100%' }}
          >
            <Grid
              container
              width={{ sm: isScrolled ? 320 : 400, xs: '100%' }}
              bgcolor="#3287e1"
              borderRadius={{ sm: 2 }}
              p={1}
              sx={{
                transition: 'width 0.3s ease',
              }}
            >
              <Grid item xs={12} sx={{ mb: isScrolled ? 0.5 : 2 }}>
                <Typography
                  color="white"
                  whiteSpace="nowrap"
                  textAlign="center"
                >
                  この企業の
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Stack
                  direction="row"
                  spacing={1}
                  justifyContent="space-between"
                >
                  {buttonsAction.map((item, index) => (
                    <Link
                      key={index}
                      href="#"
                      underline="none"
                      fontWeight={500}
                      sx={{
                        bgcolor: 'white',
                        borderRadius: 2,
                        color: '#323232',
                        fontSize: {
                          sm: isScrolled ? 14 : 18,
                          xs: 14,
                        },
                        px: isScrolled ? 0 : 2,
                        py: isScrolled ? 0.5 : 1,
                        textAlign: 'center',
                        transition: 'transform 0.3s ease, padding 0.3s ease',
                        width: '100%',
                      }}
                      onClick={(e) => {
                        e.preventDefault();
                        item.action();
                      }}
                    >
                      {item.title}
                    </Link>
                  ))}
                </Stack>
              </Grid>
            </Grid>
          </Stack>
        )}
      </Stack>
    </Stack>
  );
}
